import { ErrorKey } from 'src/app/core/constants/error-handling-list/error-ignore-list';

export const ErrorCode = {
  ScheduledRoundAlreadyCompleted: 'SCHEDULED_ROUND_ALREADY_COMPLETED',
  ReportArchivedEmployeeAccessDenied: 'REPORT_ARCHIVED_EMPLOYEE_ACCESS_DENIED',
} as const satisfies Record<string, ErrorKey>;
